/* 🤖 this file was generated by svg-to-ts */
export const matIconGpsNotFixed: {
  name: 'gps-not-fixed';
  data: string;
} = {
  name: 'gps-not-fixed',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20.94 11A8.994 8.994 0 0 0 13 3.06V1h-2v2.06A8.994 8.994 0 0 0 3.06 11H1v2h2.06A8.994 8.994 0 0 0 11 20.94V23h2v-2.06A8.994 8.994 0 0 0 20.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"/></svg>`
};
